const palette = [
    'rgba(9,84,200,0.78)',
    'rgba(231,33,33,0.6)',
    'rgba(212,131,64,0.6)',
    'rgba(191,185,45,0.6)'
]

export {palette}